import React, { useState, useEffect, useRef } from "react";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Grid from "@mui/material/Grid";
import Autocomplete from "@mui/material/Autocomplete";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
import DashboardLayout from "../../../../../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../../../../../examples/Navbars/DashboardNavbar";
import CrudService from "services/cruds-service";
import "jspdf-autotable";
import Footer from "../../../../../../examples/Footer";
import countryOptions from "../../components/List/Countries";
import MenuItem from "@mui/material/MenuItem";
import MDDropzone from "../../../../../../components/MDDropzone";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { isValid } from "date-fns";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { tr } from "date-fns/locale";
import UploadedFilePreview from "components/MDDropzone/UploadedFilePreview";
import { Tabs, Tab } from "@mui/material";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import { Box, FormControlLabel } from "@mui/material";
// Büyük formda her tuşta tüm formun yeniden çizilmesini önleyen tamponlu TextField (yazma gecikmesi)
import TextField from "components/BufferedTextField";
import Checkbox from "@mui/material/Checkbox";
import Switch from "@mui/material/Switch";
import Chip from "@mui/material/Chip";
import DownloadIcon from "@mui/icons-material/Download";
import MarkEmailReadIcon from "@mui/icons-material/MarkEmailRead";
import {t} from "../../../../../../langs";
import Typography from "@mui/material/Typography";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import AddCircle from "@mui/icons-material/AddCircle";
import RemoveCircle from "@mui/icons-material/RemoveCircle";
import { AddRowButton, RemoveRowButton } from "components/RowActions";
import { ReadOnlyBanner, ReadOnlyFieldset } from "components/ReadOnlyLock";

const CreateServiceProvider= ({ isModal = false, onClose, onCreated }) =>{

const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState(0);

    const serviceProviderOptions = [
        { label: "Sole Proprietorship" },
        { label: "General Partnership" },
        { label: "Limited Partnership" },
        { label: "Limited Liability Company (LLC)" },
        { label: "Joint Stock Company / Corporation (Inc.)" },
        { label: "Limited Liability Partnership (LLP)" },
        { label: "Cooperative" },
        { label: "Nonprofit Association" },
        { label: "Foundation" },
        { label: "Joint Venture" },
        { label: "Holding Company" },
        { label: "Branch Office" },
        { label: "Representative Office" },
        { label: "Franchise" },
    ];

    // serviceProviderOptions altına ekle
    const truckTypeOptions = [
        { label: "Curtainsider (Tautliner) 13.6" },
        { label: "Mega Trailer" },
        { label: "Jumbo Trailer" },
        { label: "Box (Dry Van)" },
        { label: "Reefer (Frigo)" },
        { label: "Flatbed" },
        { label: "Lowbed/Lowboy" },
        { label: "Container Chassis" },
        { label: "Tanker (ADR)" },
        { label: "Car Carrier" },
        { label: "Tipper/Dumper" },
        { label: "Double Deck" },
        { label: "Minivan" },
        { label: "Panelvan" },
        { label: "Pickup" },
        { label: "Rigid 7.5t" },
        { label: "Rigid 12t" },
        { label: "Rigid 26t" }
    ];

    const serviceProviderTypeOptions = [
        { label: "Warehouse Bounded" },
        { label: "Warehouse Non-Bounded" },
        { label: "Lashing" },
        { label: "International FTL Trucker" },
        { label: "International LTL Trucker" },
        { label: "Domestic FTL Trucker" },
        { label: "Domestic LTL Trucker" },
        { label: "Container Trucker" },
        { label: "OOG/Heavy International Trucker" },
        { label: "OOG/Heavy Domestic Trucker" },
    ];

    const departmentOptions = [
        "Management",
        "Ocean",
        "Air",
        "Project",
        "Road",
        "Sales",
        "Pricing",
        "Finance",
    ];


    const [salesRepOptions, setSalesRepOptions] = useState([]);

    useEffect(() => {
        const fetchSalesReps = async () => {
            try {
                const response = await CrudService.getUsers();
                const users = response.data;

                const formattedUsers = users.map(user => ({
                    id: user.id,
                    label: user.attributes.name
                }));

                setSalesRepOptions(formattedUsers);
            } catch (error) {
                console.error("Satış temsilcileri alınamadı:", error);
            }
        };

        fetchSalesReps();
    }, []);



    const [loading, setLoading] = useState(false); // Yüklenme durumu
    const [isEditing, setIsEditing] = useState(false); // Düzenleme modu
    const searchParams = new URLSearchParams(location.search); // Query parametrelerini yakalıyoruz
    const serviceProviderId = isModal ? null : searchParams.get("id");
    // An existing service provider opens read-only, like the TMS pages; "Edit" unlocks the form.
    const [readOnlyMode, setReadOnlyMode] = useState(Boolean(serviceProviderId));
    useEffect(() => {
        setReadOnlyMode(Boolean(serviceProviderId));
    }, [serviceProviderId]);
    const [successMessage, setSuccessMessage] = useState("");
    const successMessageRef = useRef(null); // Ref oluşturuldu

    const [referenceSource, setReferenceSource] = useState("");
    const [referencePerson, setReferencePerson] = useState("");
    const [isHouseAccountRef, setIsHouseAccountRef] = useState(false);
    const [externalType, setExternalType] = useState("");
    const [externalPersonName, setExternalPersonName] = useState("");
    const [externalForwardTo, setExternalForwardTo] = useState(null);
    const [externalCompany, setExternalCompany] = useState(null);
    const [companyOptions, setCompanyOptions] = useState([]);
    const [companyLoading, setCompanyLoading] = useState(false);

    const salesTeamPeople = ["Ali Kaya Koç", "Emre Akbıyık", "Hamdi Gülşen"];

    const managementPeople = [
        "Olcay Gülşen",
        "Sedat Gökmen",
        "Mehmet İkmaz",
        "Emin Kaydu",
        "Beyhan Özgün",
    ];
    const showSnackbar = (message, severity = "success") => {
        setSnackbar({
            open: true,
            message,
            severity,
        });
    };

    const handleSnackbarClose = (_, reason) => {
        if (reason === "clickaway") return;
        setSnackbar(prev => ({ ...prev, open: false }));
    };

    const normalizeReps = (data) => {
        if (!Array.isArray(data) || data.length === 0) {
            return [{ name:"", phone:"", email:"", title:"", department:[], country:"", city:"" }];
        }
        return data.map(r => ({
            name: r.name || "",
            phone: r.phone || "",
            email: r.email || "",
            title: r.title || "",
            department: Array.isArray(r.department) ? r.department : [],
            country: r.country || "",
            city: r.city || ""
        }));
    };

    useEffect(() => {
        const fetchCompanies = async () => {
            setCompanyLoading(true);

            try {
                const res = await CrudService.getCustomers();
                const raw = res?.data?.data || res?.data || [];

                const normalized = raw
                    .map((item) => {
                        const id = item?.id || item?._id || item?.attributes?._id;
                        const name = item?.attributes?.name || item?.name;

                        if (!name) return null;

                        return {
                            label: String(name).toUpperCase(),
                            value: id || String(name),
                        };
                    })
                    .filter(Boolean);

                const uniq = Array.from(
                    new Map(normalized.map((x) => [x.label, x])).values()
                );

                setCompanyOptions(uniq);
            } catch (error) {
                console.error("Company list fetch error:", error);
                setCompanyOptions([]);
            } finally {
                setCompanyLoading(false);
            }
        };

        fetchCompanies();
    }, []);


    const fetchServiceProviderDetails = async (id) => {
        setLoading(true);
        try {
            const response = await CrudService.getServiceProviderById(id);
            const serviceProviderData = response.data.attributes;
            setServiceProviderCountry(serviceProviderData.serviceProviderCountry || "");
            setSalesRep(
                Array.isArray(serviceProviderData.salesRep)
                    ? salesRepOptions.filter(repOption =>
                        serviceProviderData.salesRep.includes(repOption.id)
                    )
                    : []
            );
            const initialFinancialBlocks =
                Array.isArray(serviceProviderData.financialInfoByProduct) &&
                serviceProviderData.financialInfoByProduct.length > 0
                    ? serviceProviderData.financialInfoByProduct.map((item) => ({
                        ...defaultFinancialBlock,
                        ...item,

                        financialTerms: {
                            road: item.financialTerms?.road || {
                                paymentTerms: item.paymentTerms || 0,
                                creditLimit: item.creditLimit || 0,
                                currency: item.currency || "USD",
                            },

                            ocean: item.financialTerms?.ocean || {
                                paymentTerms: 0,
                                creditLimit: 0,
                                currency: "USD",
                            },

                            air: item.financialTerms?.air || {
                                paymentTerms: 0,
                                creditLimit: 0,
                                currency: "USD",
                            },
                        },

                        bankDetails: item.bankDetails?.length
                            ? item.bankDetails
                            : [
                                {
                                    bankName: "",
                                    swiftCode: "",
                                    iban: item.iban || "",
                                    currency: item.currency || "USD",
                                },
                            ],
                    }))
                    : [
                        {
                            ...defaultFinancialBlock,
                        },
                    ];
            setFinancialInfoByProduct(initialFinancialBlocks);
            setName(serviceProviderData.name || "");
            setTaxID(serviceProviderData.taxID || "");
            setTaxOffice(serviceProviderData.taxOffice || "");
            // Show the e-Invoice status saved with the card, as long as it was
            // checked for the tax ID that is on the card now.
            if (
                serviceProviderData.eInvoice?.checkedAt &&
                serviceProviderData.eInvoice.checkedTaxID === String(serviceProviderData.taxID || "").trim()
            ) {
                setEdmLookup({
                    status: "done",
                    checkedId: serviceProviderData.eInvoice.checkedTaxID,
                    registered: Boolean(serviceProviderData.eInvoice.isRegistered),
                    title: serviceProviderData.eInvoice.title || "",
                    alias: serviceProviderData.eInvoice.alias || "",
                    environment: serviceProviderData.eInvoice.environment || "",
                    checkedAt: serviceProviderData.eInvoice.checkedAt,
                    saved: true,
                });
            }
            setServiceProviderTypes(serviceProviderData.serviceProviderTypes || "");
            setBillingAddress(serviceProviderData.billingAddress || "");
            setPhone(serviceProviderData.phone || "");
            setEmail(serviceProviderData.email || "");
            setWebsite(serviceProviderData.website || "");
            setPaymentTerms(
                typeof serviceProviderData.paymentTerms === "number"
                    ? serviceProviderData.paymentTerms
                    : 0
            );

            setCreditLimit(
                typeof serviceProviderData.creditLimit === "number"
                    ? serviceProviderData.creditLimit
                    : 0
            );
            setCurrency(serviceProviderData.currency || "");
            setIban(serviceProviderData.iban || "");
            setContactPersonName(serviceProviderData.contactPersonName || "");
            setContactPersonTitle(serviceProviderData.contactPersonTitle || "");
            setContactPersonInfo(serviceProviderData.contactPersonInfo || "");
            setServiceProviderCategory(serviceProviderData.serviceProviderCategory || "");
            setServiceProviderStatus(serviceProviderData.serviceProviderStatus || "");
            setServiceProviderNo(serviceProviderData.serviceProviderNo || "");
            setShippingPreferences(serviceProviderData.shippingPreferences || "");
            setSpecialNotes(serviceProviderData.specialNotes || "");
            setTransactionNotes(serviceProviderData.transactionNotes || "");
            setComplaintHistory(serviceProviderData.complaintHistory || "");
            setVehicleInsurances(serviceProviderData.vehicleInsurances || null);
            setMtlInsurances(serviceProviderData.mtlInsurances || null);
            setCargoPolicy(serviceProviderData.cargoPolicy || null);
            setProviderAgreement(serviceProviderData.providerAgreement || null);
            setVehicleInsurancesDate(parseDate(serviceProviderData.vehicleInsurancesDate));
            setMtlInsurancesDate(parseDate(serviceProviderData.mtlInsurancesDate));
            setCargoPolicyDate(parseDate(serviceProviderData.cargoPolicyDate));
            setProviderAgreementDate(parseDate(serviceProviderData.providerAgreementDate));
            setServiceProviderScope(serviceProviderData.serviceProviderScope || "Cross Border Trucker");
            setOperatingCountries(serviceProviderData.operatingCountries || []);
            setTruckTypes(serviceProviderData.truckTypes || []);
            setByTypeOfCollaboration(normalizeArray(serviceProviderData.byTypeOfCollaboration));
            setServiceProviderTypesGroup(normalizeArray(serviceProviderData.serviceProviderTypesGroup));
            setRepresentatives(normalizeReps(serviceProviderData.representatives));
            setFinanceRepresentatives(normalizeReps(serviceProviderData.financeRepresentatives));
            setPricingRepresentatives(normalizeReps(serviceProviderData.pricingRepresentatives));
            setOperationRepresentatives(normalizeReps(serviceProviderData.operationRepresentatives));
            setCity(serviceProviderData.city || "");
            const refs = serviceProviderData.references || {};

            setReferenceSource(refs.source || "");

            if (refs.source === "Sales Team") {
                setReferencePerson(refs.salesTeamPerson || "");
            }

            if (refs.source === "Management") {
                setReferencePerson(refs.managementPerson || "");
                setIsHouseAccountRef(!!refs.managementHouseAccount);
            }

            if (refs.source === "External") {
                setExternalType(refs.externalType || "");
                setExternalPersonName(refs.externalPersonFullName || "");

                if (refs.externalForwardToSalesRep) {
                    const selectedRep = salesRepOptions.find(
                        rep => rep.id === refs.externalForwardToSalesRep
                    );

                    setExternalForwardTo(selectedRep || null);
                }

                if (refs.externalCompany) {
                    const selectedCompany = companyOptions.find(
                        company =>
                            company.value === refs.externalCompany ||
                            company.label === refs.externalCompany
                    );

                    setExternalCompany(selectedCompany || null);
                }
            }
        } catch (error) {
            console.error("Error fetching serviceProvider details:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (
            serviceProviderId &&
            salesRepOptions.length > 0 &&
            companyOptions.length > 0
        ) {
            setIsEditing(true);
            fetchServiceProviderDetails(serviceProviderId);
        }
    }, [
        serviceProviderId,
        salesRepOptions,
        companyOptions
    ]);


    const [salesRep, setSalesRep] = useState([]);
    const [name, setName] = useState("");
    const [serviceProviderCountry, setServiceProviderCountry] = useState("");
    const [taxID, setTaxID] = useState("");
    const [taxOffice, setTaxOffice] = useState("");
    // EDM e-Fatura lookup for the entered tax ID: { status, registered, title, alias, checkedId }
    const [edmLookup, setEdmLookup] = useState({ status: "idle" });

    // Asks EDM whether the entered VKN/TCKN is a registered e-Fatura user and, if
    // so, pre-fills the service provider name with EDM's registered title (only
    // when the name is still empty -- an existing name is never overwritten).
    const lookupTaxIdInEdm = async () => {
        const identifier = String(taxID || "").trim();

        if (!/^\d{10,11}$/.test(identifier)) {
            setEdmLookup({ status: "idle" });
            return;
        }

        if (edmLookup.checkedId === identifier && edmLookup.status !== "error") return;

        setEdmLookup({ status: "loading", checkedId: identifier });

        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/edm/check-user`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
                body: JSON.stringify({ identifier }),
            });
            const result = await response.json().catch(() => ({}));

            if (!response.ok || !result.success) {
                throw new Error(result.error || "EDM lookup failed.");
            }

            setEdmLookup({
                status: "done",
                checkedId: identifier,
                registered: Boolean(result.isRegistered),
                title: result.title || "",
                alias: result.alias || "",
                environment: result.environment || "",
            });

            if (result.isRegistered && result.title && !String(name || "").trim()) {
                setName(String(result.title).toUpperCase());
            }
        } catch (error) {
            setEdmLookup({ status: "error", checkedId: identifier, message: error.message });
        }
    };
    const [serviceProviderTypes, setServiceProviderTypes] = useState("");
    const [billingAddress, setBillingAddress] = useState("");
    const [phone, setPhone] = useState("");
    const [email, setEmail] = useState("");
    const [website, setWebsite] = useState("");

    const [paymentTerms, setPaymentTerms] = useState(0);
    const [creditLimit, setCreditLimit] = useState(0);
    const [currency, setCurrency] = useState("");
    const [iban, setIban] = useState('');
    const [representatives, setRepresentatives] = useState([{ name: "", phone: "", email: "", title: "", department: [], country: "", city: "" }]);
    const [financeRepresentatives, setFinanceRepresentatives]= useState([{ name: "", phone: "", email: "", title: "", department: [], country: "", city: "" }]);
    const [pricingRepresentatives, setPricingRepresentatives] = useState([{ name: "", phone: "", email: "", title: "", department: [], country: "", city: "" }]);
    const [operationRepresentatives, setOperationRepresentatives] = useState([{ name: "", phone: "", email: "", title: "", department: [], country: "", city: "" }]);
    const [contactPersonName, setContactPersonName] = useState(''); // İlgili kişi adı için state
    const [contactPersonTitle, setContactPersonTitle] = useState(''); // İlgili kişi unvanı için state
    const [contactPersonInfo, setContactPersonInfo] = useState(''); // İlgili kişi iletişim bilgileri için state
    const [serviceProviderCategory, setServiceProviderCategory] = useState(0); // Müşteri kategorisi için state
    const [serviceProviderStatus, setServiceProviderStatus] = useState(''); // Müşteri durumu için state
    const [serviceProviderNo, setServiceProviderNo] = useState(''); // Müşteri ID için state
    const [shippingPreferences, setShippingPreferences] = useState([]); // Gönderim Tercihleri için state
    const [specialNotes, setSpecialNotes] = useState(''); // Özel Notlar için state
    const [transactionNotes, setTransactionNotes] = useState(''); // İşlem Geçmişi Notları için state
    const [complaintHistory, setComplaintHistory] = useState(''); // Şikayet/Destek Geçmişi için state
    const [vehicleInsurances, setVehicleInsurances] = useState(null);
    const [mtlInsurances, setMtlInsurances] = useState(null);
    const [cargoPolicy, setCargoPolicy] = useState(null);
    const [providerAgreement, setProviderAgreement] = useState(null);
    const [vehicleInsurancesDate, setVehicleInsurancesDate] = useState(null);
    const [mtlInsurancesDate, setMtlInsurancesDate] = useState(null);
    const [cargoPolicyDate, setCargoPolicyDate] = useState(null);
    const [providerAgreementDate, setProviderAgreementDate] = useState(null);
    const [serviceProviderScope, setServiceProviderScope] = useState('Cross Border Trucker'); // "Cross Border Trucker" | "Domestic"
    const [operatingCountries, setOperatingCountries] = useState([]);     // ["Turkey","Germany",...]
    const [truckTypes, setTruckTypes] = useState([]);                      // ["Reefer (Frigo)", ...]
    const [byTypeOfCollaboration, setByTypeOfCollaboration] = useState([]);
    const [serviceProviderTypesGroup, setServiceProviderTypesGroup] = useState([]);
    const [city, setCity] = useState("");

    const [snackbar, setSnackbar] = useState({
        open: false,
        message: "",
        severity: "success", // success | error | warning | info
    });

    const defaultFinancialBlock = {
        id: Date.now(),

        financialTerms: {
            road: {
                paymentTerms: 0,
                creditLimit: 0,
                currency: "USD",
            },
            ocean: {
                paymentTerms: 0,
                creditLimit: 0,
                currency: "USD",
            },
            air: {
                paymentTerms: 0,
                creditLimit: 0,
                currency: "USD",
            },
        },

        dateType: "Invoice Date",

        bankDetails: [
            {
                bankName: "",
                swiftCode: "",
                iban: "",
                currency: "USD",
            },
        ],
    };
    const [financialInfoByProduct, setFinancialInfoByProduct] = useState([
        { ...defaultFinancialBlock },
    ]);

    const addFinancialBlock = () => {
        setFinancialInfoByProduct((prev) => [...prev, { ...defaultFinancialBlock }]);
    };

    const removeFinancialBlock = (indexToRemove) => {
        setFinancialInfoByProduct((prev) =>
            prev.filter((_, idx) => idx !== indexToRemove)
        );
    };


    // Submit işlemi için gerekli fonksiyon
    const submitHandler = async (e) => {
        e.preventDefault();

        const serviceProviderData = {
            name,
            serviceProviderCountry,
            salesRep: salesRep.map(rep => rep.id),
            taxID,
            taxOffice,
            serviceProviderTypes,
            billingAddress,
            phone,
            email,
            website,
            pricingRepresentatives,
            representatives,
            financeRepresentatives,
            operationRepresentatives,
            financialInfoByProduct,
            contactPersonName,
            contactPersonTitle,
            contactPersonInfo,
            serviceProviderCategory,
            serviceProviderStatus,
            serviceProviderNo,
            shippingPreferences,
            specialNotes,
            transactionNotes,
            complaintHistory,
            vehicleInsurancesDate,
            serviceProviderScope,
            operatingCountries,
            truckTypes,
            byTypeOfCollaboration,
            serviceProviderTypesGroup,
            city,
            references: {
                source: referenceSource,
                salesTeamPerson: referenceSource === "Sales Team" ? referencePerson || null : null,
                managementPerson: referenceSource === "Management" ? referencePerson || null : null,
                managementHouseAccount: referenceSource === "Management" ? !!isHouseAccountRef : false,
                externalType: referenceSource === "External" ? externalType : null,
                externalPersonFullName:
                    referenceSource === "External" && externalType === "In Person"
                        ? externalPersonName || null
                        : null,
                externalForwardToSalesRep:
                    referenceSource === "External" && externalType === "In Person"
                        ? externalForwardTo?.id || null
                        : null,
                externalCompany:
                    referenceSource === "External" && externalType === "Company"
                        ? externalCompany?.value || null
                        : null,
            },
        };

        const formData = new FormData();

        const fileMap = {
            vehicleInsurances,
            mtlInsurances,
            cargoPolicy,
            providerAgreement,
        };

        function appendFileSmart(fieldName, fileArray) {
            if (fileArray?.[0]) {
                formData.append(fieldName, fileArray[0]);
            } else if (isEditing) {
                serviceProviderData[fieldName] = null;
            }
        }

        Object.entries(fileMap).forEach(([field, fileArray]) => {
            appendFileSmart(field, fileArray);
        });

        formData.append("data", JSON.stringify(serviceProviderData));
        try {
            setLoading(true);
            let response;

            if (isEditing) {
                response = await CrudService.updateServiceProvider(formData, serviceProviderId);
                showSnackbar("Service provider updated successfully.", "success");
            } else {
                response = await CrudService.createServiceProvider(formData);
                showSnackbar("Service provider created successfully.", "success");
            }

            if (isModal) {
                const created =
                    response?.data?.data ||
                    response?.data?.attributes ||
                    response?.data;

                onCreated?.(created);
                onClose?.();
                return;
            }

            window.scrollTo({ top: 0, behavior: "smooth" });

            setTimeout(() => {
                navigate("/service-provider/service-provider-tables/details");
            }, 3000);
        }catch (err) {
                if (err.response?.status === 409) {
                    showSnackbar(
                        err.response?.data?.errors?.[0]?.detail || "This service provider already exists.",
                        "error"
                    );
                    return;
                }

                showSnackbar(
                    err.response?.data?.errors?.[0]?.detail || "Service provider could not be created.",
                    "error"
                );
            }
        finally {
            setLoading(false);
        }
    };
// --- Cities cache + options ---
    const cityCacheRef = useRef(new Map()); // key: countryLabel -> string[]
    const [spCityOptions, setSpCityOptions] = useState([]);
    const [spCityLoading, setSpCityLoading] = useState(false);

    const fetchCitiesByCountry = async (countryLabel) => {
        if (!countryLabel) return [];

        if (cityCacheRef.current.has(countryLabel)) {
            return cityCacheRef.current.get(countryLabel);
        }

        const resp = await CrudService.getCitiesByCountry(countryLabel);
        const raw = resp?.data?.data ?? resp?.data ?? [];
        const arr = Array.isArray(raw) ? raw : [];

        const list = arr
            .map((x) => (typeof x === "string" ? x : x?.name || x?.label || x?.city))
            .filter(Boolean);

        const normalized = Array.from(new Set(list)).sort((a, b) => a.localeCompare(b));
        cityCacheRef.current.set(countryLabel, normalized);
        return normalized;
    };

    useEffect(() => {
        let ignore = false;

        const run = async () => {
            if (!serviceProviderCountry) {
                setSpCityOptions([]);
                return;
            }

            setSpCityLoading(true);
            try {
                const list = await fetchCitiesByCountry(serviceProviderCountry);
                if (!ignore) setSpCityOptions(list);
            } catch (e) {
                console.error("SP cities fetch failed:", e);
                if (!ignore) setSpCityOptions([]);
            } finally {
                if (!ignore) setSpCityLoading(false);
            }
        };

        run();
        return () => { ignore = true; };
    }, [serviceProviderCountry]);


    const addPricingRepresentative = () => {
        setPricingRepresentatives([...pricingRepresentatives, {
            name: "", phone: "", email: "", title: "", department: [], country: "", city: ""
        }]);
    };

    const removePricingRepresentative = (index) => {
        const arr = [...pricingRepresentatives];
        arr.splice(index, 1);
        setPricingRepresentatives(arr);
    };

    const updatePricingRepresentative = (index, field, value) => {
        const arr = [...pricingRepresentatives];
        arr[index][field] = value;
        setPricingRepresentatives(arr);
    };

    const addOperationRepresentative = () => {
        setOperationRepresentatives([...operationRepresentatives, {
            name: "", phone: "", email: "", title: "", department: [], country: "", city: ""
        }]);
    };

    const removeOperationRepresentative = (index) => {
        const arr = [...operationRepresentatives];
        arr.splice(index, 1);
        setOperationRepresentatives(arr);
    };

    const updateOperationRepresentative = (index, field, value) => {
        const arr = [...operationRepresentatives];
        arr[index][field] = value;
        setOperationRepresentatives(arr);
    };


    const addRepresentative = () => {
        setRepresentatives([
            ...representatives,
            { name: "", phone: "", email: "", title: "", department: [], country: "", city: "" }
        ]);
    };

    const removeRepresentative = (index) => {
        const updated = [...representatives];
        updated.splice(index, 1);
        setRepresentatives(updated);
    };

    const updateRepresentative = (index, field, value) => {
        const updated = [...representatives];
        updated[index][field] = value;
        setRepresentatives(updated);
    };

    const addFinanceRepresentative = () => {
        setFinanceRepresentatives([
            ...financeRepresentatives,
            { name: "", phone: "", email: "", title: "", department: [], country: "", city: "" }
        ]);
    };

    const removeFinanceRepresentative = (index) => {
        const updated = [...financeRepresentatives];
        updated.splice(index, 1);
        setFinanceRepresentatives(updated);
    };

    const updateFinanceRepresentative = (index, field, value) => {
        const updated = [...financeRepresentatives];
        updated[index][field] = value;
        setFinanceRepresentatives(updated);
    };

    const parseDate = (dateString) => {
        if (!dateString) return new Date(); // Varsayılan olarak bugünü al
        try {
            const parsedDate = new Date(dateString);
            return isValid(parsedDate) ? parsedDate : new Date();
        } catch (error) {
            return new Date(); // Geçersizse bugünün tarihi döndür
        }
    };

    const TITLE_SX = {
        fontWeight: "bold",
        lineHeight: 1.15,
        height: 15,                 // 2 satır için sabit yükseklik
        mb: 1,                      // başlık-kutu arası sabit boşluk
        display: "-webkit-box",
        WebkitLineClamp: 2,
        WebkitBoxOrient: "vertical",
        overflow: "hidden",
        textOverflow: "ellipsis",
        textAlign: "center",
    };

    const DROPZONE_WRAPPER_SX = {
        width: "100%",
        maxWidth: "90px",
        height: "150px",
        overflow: "hidden",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    };

    const DZ_STYLE = {
        height: "80px",
        minHeight: "80px",
        maxHeight: "80px",
        fontSize: "8px",
        overflow: "hidden"
    };

    const normalizeArray = (field) =>
        Array.isArray(field)
            ? field
            : field
                ? [field]
                : [];

    const repCityCacheRef = useRef(new Map()); // key: country -> cities[]
    const [repCityOptionsMap, setRepCityOptionsMap] = useState({});
// örn: { "Turkey": ["Istanbul", ...], "Germany": [...] }

    const ensureCitiesLoaded = async (countryLabel) => {
        if (!countryLabel) return [];

        if (repCityCacheRef.current.has(countryLabel)) return repCityCacheRef.current.get(countryLabel);

        const list = await fetchCitiesByCountry(countryLabel);
        repCityCacheRef.current.set(countryLabel, list);
        setRepCityOptionsMap((p) => ({ ...p, [countryLabel]: list }));
        return list;
    };

    const addBankDetail = (financeIndex) => {
        setFinancialInfoByProduct((prev) => {
            const updated = [...prev];

            updated[financeIndex] = {
                ...updated[financeIndex],
                bankDetails: [
                    ...(updated[financeIndex].bankDetails || []),
                    { bankName: "", swiftCode: "", iban: "", currency: "USD" },
                ],
            };

            return updated;
        });
    };

    const removeBankDetail = (financeIndex, bankIndex) => {
        setFinancialInfoByProduct((prev) => {
            const updated = [...prev];

            updated[financeIndex] = {
                ...updated[financeIndex],
                bankDetails: updated[financeIndex].bankDetails.filter((_, i) => i !== bankIndex),
            };

            return updated;
        });
    };

    const defaultFinancialTerms = {
        road: {
            paymentTerms: 0,
            creditLimit: 0,
            currency: "USD",
        },
        ocean: {
            paymentTerms: 0,
            creditLimit: 0,
            currency: "USD",
        },
        air: {
            paymentTerms: 0,
            creditLimit: 0,
            currency: "USD",
        },
    };

    const updateFinancialTerm = (
        financeIndex,
        mode,
        field,
        value
    ) => {
        setFinancialInfoByProduct((prev) => {
            const updated = [...prev];

            const currentBlock = updated[financeIndex] || {};

            const currentFinancialTerms = {
                ...defaultFinancialTerms,
                ...(currentBlock.financialTerms || {}),
            };

            updated[financeIndex] = {
                ...currentBlock,
                financialTerms: {
                    ...currentFinancialTerms,
                    [mode]: {
                        ...defaultFinancialTerms[mode],
                        ...(currentFinancialTerms[mode] || {}),
                        [field]: value,
                    },
                },
            };

            return updated;
        });
    };

    const updateBankDetail = (financeIndex, bankIndex, field, value) => {
        setFinancialInfoByProduct((prev) => {
            const updated = [...prev];
            const bankDetails = [...(updated[financeIndex].bankDetails || [])];

            bankDetails[bankIndex] = {
                ...bankDetails[bankIndex],
                [field]: value,
            };

            updated[financeIndex] = {
                ...updated[financeIndex],
                bankDetails,
            };

            return updated;
        });
    };
    const formContent = (
        <>
            <MDBox mt={3}>
                <MDBox mb={3}>
                    <Grid container justifyContent="center">
                        <Grid item xs={12} lg={12}>
                            <MDBox mb={1} textAlign="center">
                                {/* Başarı Mesajı */}
                                <div
                                    ref={successMessageRef} // Ref burada tanımlandı
                                    style={{
                                        backgroundColor: successMessage ? "#ECFDF3" : "transparent",
                                        color: successMessage ? "#027A48" : "transparent",
                                        border: successMessage ? "1px solid #ABEFC6" : "none",
                                        fontWeight: 600,
                                        padding: "10px",
                                        textAlign: "center",
                                        marginBottom: "10px",
                                        borderRadius: "5px",
                                        visibility: successMessage ? "visible" : "hidden", // Mesaj yoksa görünmez
                                    }}
                                >
                                    {successMessage}
                                    {successMessage}
                                </div>
                                <MDBox mb={1}>
                                    <MDTypography variant="h3" fontWeight="bold">
                                        {isEditing
                                            ? " Edit Service Provider Card Details"
                                            : " Add Service Provider Card Details"}
                                    </MDTypography>
                                </MDBox>
                                <MDTypography variant="h5" fontWeight="regular" color="secondary">
                                    This information will give you more information about the Service Provider Card. </MDTypography>
                            </MDBox>
                        </Grid>
                    </Grid>
                </MDBox>

                {readOnlyMode && (
                    <ReadOnlyBanner
                        message="This service provider is in read-only view. Click Edit to make changes."
                        onEdit={() => setReadOnlyMode(false)}
                    />
                )}

                <Box sx={{ borderBottom: 1, borderColor: "divider", mt: 3 }}>
                    <Tabs
                        value={activeTab}
                        onChange={(e, val) => setActiveTab(val)}
                        centered
                    >
                        <Tab label="General Information" />
                        <Tab label="Contact List & Documents" />
                    </Tabs>
                </Box>

                <ReadOnlyFieldset readOnly={readOnlyMode}>
                <MDBox mb={3} mt={2}
                       sx={{
                           p: 3,
                           borderRadius: "10px",
                           bgcolor: "background.paper",
                           boxShadow: "none",
                       }}>
                    <Grid container justifyContent="center">
                        <Grid item xs={12} lg={12}>
                            {activeTab === 0 && (
                                <>
                                    <MDBox>
                                        <MDBox mt={3}>
                                            <MDTypography variant="h6">Basic Information</MDTypography>
                                        </MDBox>
                                        <Grid container spacing={3} mt={1}>

                                            {/* Service Provider Name */}
                                            <Grid item xs={12} sm={4}>
                                                <TextField
                                                    type="text"
                                                    label="Service Provider Name"
                                                    value={name}
                                                    onChange={(e) => setName(e.target.value)}
                                                    InputLabelProps={{shrink: true}}
                                                    sx={{
                                                        "& .MuiInputBase-root": {height: 40},
                                                    }}
                                                    fullWidth
                                                />
                                            </Grid>

                                            {/* Service Provider Country */}
                                            <Grid item xs={12} sm={4}>
                                                <Autocomplete
                                                    options={countryOptions}
                                                    getOptionLabel={(option) => option.label}
                                                    value={countryOptions.find((c) => c.label === serviceProviderCountry) || null}
                                                    onChange={(event, newValue) =>
                                                        setServiceProviderCountry(newValue ? newValue.label : "")
                                                    }
                                                    isOptionEqualToValue={(option, value) => option.label === value.label}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            label="Select Service Provider Country"
                                                            InputLabelProps={{shrink: true}}
                                                            sx={{
                                                                "& .MuiInputBase-root": {height: 40},
                                                                "& input": {padding: "0 !important", height: "40px !important"},
                                                            }}
                                                            fullWidth
                                                        />
                                                    )}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={4}>
                                                <Autocomplete
                                                    freeSolo
                                                    options={spCityOptions}
                                                    loading={spCityLoading}
                                                    value={city || ""}
                                                    onChange={(_e, v) => setCity(v || "")}
                                                    onInputChange={(_e, v) => setCity(v || "")}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            label="City"
                                                            InputLabelProps={{ shrink: true }}
                                                            sx={{ "& .MuiInputBase-root": { height: 40 } }}
                                                            fullWidth
                                                        />
                                                    )}
                                                />
                                            </Grid>




                                        </Grid>
                                        <MDBox mt={3}>
                                            <Grid container spacing={3}>
                                                {/* Tax ID */}
                                                <Grid item xs={12} sm={4}>
                                                    <TextField
                                                        type="text"
                                                        label="Tax ID / Identity Number"
                                                        value={taxID}
                                                        onChange={(e) => {
                                                            setTaxID(e.target.value);
                                                            if (edmLookup.status !== "idle") setEdmLookup({ status: "idle" });
                                                        }}
                                                        onBlur={lookupTaxIdInEdm}
                                                        InputLabelProps={{shrink: true}}
                                                        sx={{
                                                            "& .MuiInputBase-root": {height: 40},
                                                        }}
                                                        fullWidth
                                                    />

                                                    {edmLookup.status === "loading" && (
                                                        <MDTypography variant="caption" color="text" display="block" mt={0.5}>
                                                            Checking EDM...
                                                        </MDTypography>
                                                    )}

                                                    {edmLookup.status === "done" && (
                                                        <MDBox mt={0.75}>
                                                            {/* "Not registered" is only a fact when it came from the
                                                                production EDM; the EDM test service knows just a few companies. */}
                                                            <Chip
                                                                size="small"
                                                                color={
                                                                    edmLookup.registered
                                                                        ? "success"
                                                                        : edmLookup.environment === "production"
                                                                            ? "default"
                                                                            : "warning"
                                                                }
                                                                variant={
                                                                    !edmLookup.registered && edmLookup.environment !== "production"
                                                                        ? "outlined"
                                                                        : "filled"
                                                                }
                                                                label={
                                                                    edmLookup.registered
                                                                        ? "e-Invoice user"
                                                                        : edmLookup.environment === "production"
                                                                            ? "Not an e-Invoice user (e-Archive)"
                                                                            : "Not found in EDM test list (not confirmed)"
                                                                }
                                                            />
                                                            {edmLookup.saved && edmLookup.checkedAt ? (
                                                                <MDTypography variant="caption" color="text" display="block" mt={0.5}>
                                                                    Saved status, checked on{" "}
                                                                    {new Date(edmLookup.checkedAt).toLocaleDateString()}
                                                                </MDTypography>
                                                            ) : null}
                                                            {edmLookup.registered && edmLookup.title ? (
                                                                <MDTypography variant="caption" color="text" display="block" mt={0.5}>
                                                                    EDM title: {edmLookup.title}
                                                                    {String(name || "").trim() &&
                                                                    String(name).trim().toUpperCase() !==
                                                                    String(edmLookup.title).trim().toUpperCase() ? (
                                                                        <>
                                                                            {" "}
                                                                            <span
                                                                                style={{ color: "#1976d2", cursor: "pointer", textDecoration: "underline" }}
                                                                                onClick={() => setName(String(edmLookup.title).toUpperCase())}
                                                                            >
                                                                                Use this name
                                                                            </span>
                                                                        </>
                                                                    ) : null}
                                                                </MDTypography>
                                                            ) : null}
                                                        </MDBox>
                                                    )}

                                                    {edmLookup.status === "error" && (
                                                        <MDTypography variant="caption" color="error" display="block" mt={0.5}>
                                                            EDM lookup failed: {edmLookup.message}
                                                        </MDTypography>
                                                    )}
                                                </Grid>
                                                {/* Tax Office */}
                                                <Grid item xs={12} sm={4}>
                                                    <TextField
                                                        type="text"
                                                        label="Tax Office"
                                                        value={taxOffice}
                                                        onChange={(e) => setTaxOffice(e.target.value)}
                                                        InputLabelProps={{shrink: true}}
                                                        fullWidth
                                                        sx={{
                                                            "& .MuiInputBase-root": {height: 40},
                                                        }}
                                                    />
                                                </Grid>

                                                {/* Service Provider Types */}
                                                <Grid item xs={12} sm={4}>
                                                    <Autocomplete
                                                        options={serviceProviderOptions}
                                                        getOptionLabel={(option) => option.label}
                                                        value={serviceProviderTypes ? {label: serviceProviderTypes} : null}
                                                        onChange={(event, newValue) =>
                                                            setServiceProviderTypes(newValue ? newValue.label : "")
                                                        }
                                                        isOptionEqualToValue={(option, value) => option.label === value.label}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                label="Select Service Provider Types"
                                                                InputLabelProps={{shrink: true}}
                                                                fullWidth
                                                                sx={{
                                                                    "& .MuiInputBase-root": {height: 50},
                                                                    "& input": {padding: "0 !important", height: "40px !important"},
                                                                }}
                                                            />
                                                        )}
                                                    />
                                                </Grid>

                                                {/* Sales Representatives */}
                                                {/*                       <Grid item xs={12} sm={3}>
                                        <Autocomplete
                                            multiple
                                            options={salesRepOptions}
                                            getOptionLabel={(option) => option.label}
                                            value={salesRep}
                                            onChange={(event, newValues) => setSalesRep(newValues)}
                                            isOptionEqualToValue={(option, value) => option.id === value.id}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="Sales Representatives"
                                                    InputLabelProps={{shrink: true}}
                                                    fullWidth
                                                    sx={{
                                                        "& .MuiInputBase-root": {height: 40},
                                                        "& input": {padding: "0 !important", height: "40px !important"},
                                                    }}
                                                />
                                            )}
                                        />
                                    </Grid>*/}

                                            </Grid>
                                        </MDBox>
                                        <br/>
                                        <MDBox>
                                            <Grid container spacing={2}>

                                                <Grid item xs={6}>
                                                    <TextField
                                                        type="text"
                                                        label="Billing Address"
                                                        value={billingAddress}
                                                        onChange={(e) => setBillingAddress(e.target.value)}
                                                        fullWidth
                                                        InputLabelProps={{shrink: true}}
                                                        sx={{
                                                            "& .MuiInputBase-root": {height: 40},
                                                        }}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </MDBox>

                                        <MDBox mt={3}>
                                            <Grid container spacing={3}>

                                                {/* Phone */}
                                                <Grid item xs={12} sm={4}>
                                                    <TextField
                                                        type="text"
                                                        label="Phone Number"
                                                        value={phone}
                                                        onChange={(e) => setPhone(e.target.value)}
                                                        fullWidth
                                                        InputLabelProps={{shrink: true}}
                                                        sx={{"& .MuiInputBase-root": {height: 40}}}
                                                    />
                                                </Grid>

                                                {/* Email */}
                                                <Grid item xs={12} sm={4}>
                                                    <TextField
                                                        type="email"
                                                        label="Email Address"
                                                        value={email}
                                                        onChange={(e) => setEmail(e.target.value)}
                                                        fullWidth
                                                        InputLabelProps={{shrink: true}}
                                                        sx={{"& .MuiInputBase-root": {height: 40}}}
                                                    />
                                                </Grid>

                                                {/* Website */}
                                                <Grid item xs={12} sm={4}>
                                                    <TextField
                                                        type="url"
                                                        label="Website"
                                                        value={website}
                                                        onChange={(e) => setWebsite(e.target.value)}
                                                        fullWidth
                                                        InputLabelProps={{shrink: true}}
                                                        sx={{"& .MuiInputBase-root": {height: 40}}}
                                                    />
                                                </Grid>

                                            </Grid>

                                        </MDBox>

                                        <Grid container spacing={3} mt={1}>

                                            {/* Service Provider Category (Scope) */}
                                            <Grid item xs={12} sm={4}>
                                                <Autocomplete
                                                    options={[
                                                        { label: "Cross Border Trucker", value: "Cross Border Trucker" },
                                                        { label: "Domestic", value: "Domestic" },
                                                    ]}
                                                    getOptionLabel={(option) => option.label}
                                                    value={
                                                        serviceProviderScope
                                                            ? { label: serviceProviderScope, value: serviceProviderScope }
                                                            : null
                                                    }
                                                    isOptionEqualToValue={(o, val) => (o?.label ?? o) === (val?.label ?? val)}
                                                    onChange={(_e, newValue) => {
                                                        const v = newValue?.value || "";
                                                        setServiceProviderScope(v);

                                                        if (v !== "Cross Border Trucker") {
                                                            setOperatingCountries([]);
                                                        }
                                                    }}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            label="Service Provider Scope"
                                                            fullWidth
                                                            InputLabelProps={{ shrink: true }}
                                                            sx={{ "& .MuiInputBase-root": { height: 50 } }}
                                                        />
                                                    )}
                                                />
                                            </Grid>


                                            {/* Operating Countries (Multiple - Only for International) */}
                                            {serviceProviderScope === "Cross Border Trucker" && (
                                                <Grid item xs={12} sm={4}>
                                                    <Autocomplete
                                                        multiple
                                                        options={countryOptions}
                                                        getOptionLabel={(option) => option.label}
                                                        value={operatingCountries
                                                            .map(lbl => countryOptions.find(c => c.label === lbl))
                                                            .filter(Boolean)
                                                        }
                                                        onChange={(event, newValue) =>
                                                            setOperatingCountries(newValue.map(item => item.label))
                                                        }
                                                        isOptionEqualToValue={(a, b) => a.label === b.label}
                                                        renderOption={({ key: optionKey, ...props }, option) => (
                                                            <li key={optionKey} {...props} style={{display: "flex", alignItems: "center", gap: 8}}>
                                                                {option.flagUrl && (
                                                                    <img src={option.flagUrl} width="20" height="15" alt=""/>
                                                                )}
                                                                {option.label}
                                                            </li>
                                                        )}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                label="Operating Countries"
                                                                fullWidth
                                                                InputLabelProps={{shrink: true}}
                                                            />
                                                        )}
                                                    />
                                                </Grid>
                                            )}

                                            {/* Truck Types (Multiple) */}
                                            <Grid item xs={12} sm={serviceProviderScope === "Cross Border Trucker" ? 4 : 4}>
                                                <Autocomplete
                                                    multiple
                                                    options={truckTypeOptions}
                                                    getOptionLabel={(option) => option.label}
                                                    value={truckTypes.map(tt => ({label: tt}))}
                                                    onChange={(event, newValue) => setTruckTypes(newValue.map(x => x.label))}
                                                    isOptionEqualToValue={(a, b) => a.label === b.label}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            label="Truck Types"
                                                            fullWidth
                                                            InputLabelProps={{shrink: true}}
                                                        />
                                                    )}
                                                />
                                            </Grid>

                                        </Grid>


                                        <MDBox mt={3}>
                                            <MDTypography variant="h6">Financial Information</MDTypography>

                                            {financialInfoByProduct.map((block, index) => (
                                                <MDBox key={index} mt={2} p={2}>
                                                    <Grid container spacing={1} alignItems="center" mb={2}>
                                                        <Grid item xs={12} sm={8}>
                                                            <MDTypography variant="subtitle2" fontWeight="bold">
                                                                Financial Terms by Product
                                                            </MDTypography>
                                                        </Grid>

                                                        <Grid item xs={12} sm={4}>
                                                            <Box display="flex" justifyContent="flex-end" gap={1}>
                                                                <AddRowButton onClick={addFinancialBlock} tooltip="Add financial info" />

                                                                {financialInfoByProduct.length > 1 && (
                                                                    <RemoveRowButton onClick={() => removeFinancialBlock(index)} tooltip="Remove financial info" />
                                                                )}
                                                            </Box>
                                                        </Grid>
                                                    </Grid>

                                                    <Grid container spacing={2}>
                                                        {["road", "ocean", "air"].map((service) => (
                                                            <Grid item xs={12} md={4} key={service}>
                                                                <MDBox
                                                                    p={2}
                                                                    border="1px solid #ddd"
                                                                    borderRadius="10px"
                                                                    sx={{
                                                                        height: "100%",
                                                                        minHeight: 420,
                                                                        overflowY: "auto",
                                                                    }}
                                                                >
                                                                    <MDTypography
                                                                        variant="h6"
                                                                        mb={2}
                                                                        textTransform="capitalize"
                                                                        fontWeight="bold"
                                                                    >
                                                                        {service}
                                                                    </MDTypography>

                                                                    <TextField
                                                                        fullWidth
                                                                        type="number"
                                                                        label="Payment Terms (days)"
                                                                        value={block.financialTerms?.[service]?.paymentTerms ?? 0}
                                                                        onChange={(e) =>
                                                                            updateFinancialTerm(
                                                                                index,
                                                                                service,
                                                                                "paymentTerms",
                                                                                Number(e.target.value)
                                                                            )
                                                                        }
                                                                        inputProps={{ min: 0, max: 120 }}
                                                                        InputLabelProps={{ shrink: true }}
                                                                        sx={{ mb: 1, "& .MuiInputBase-root": { height: 40 } }}
                                                                    />

                                                                    <input
                                                                        type="range"
                                                                        min="0"
                                                                        max="120"
                                                                        step="1"
                                                                        value={block.financialTerms?.[service]?.paymentTerms ?? 0}
                                                                        onChange={(e) =>
                                                                            updateFinancialTerm(
                                                                                index,
                                                                                service,
                                                                                "paymentTerms",
                                                                                Number(e.target.value)
                                                                            )
                                                                        }
                                                                        style={{
                                                                            width: "100%",
                                                                            cursor: "pointer",
                                                                            accentColor: "#1976d2",
                                                                        }}
                                                                    />

                                                                    <MDTypography variant="caption" display="block" mb={2}>
                                                                        {block.financialTerms?.[service]?.paymentTerms ?? 0} days
                                                                    </MDTypography>

                                                                    <TextField
                                                                        fullWidth
                                                                        type="number"
                                                                        label="Credit Limit ($)"
                                                                        value={block.financialTerms?.[service]?.creditLimit ?? 0}
                                                                        onChange={(e) =>
                                                                            updateFinancialTerm(
                                                                                index,
                                                                                service,
                                                                                "creditLimit",
                                                                                Number(e.target.value)
                                                                            )
                                                                        }
                                                                        inputProps={{ min: 0, max: 200000 }}
                                                                        InputLabelProps={{ shrink: true }}
                                                                        sx={{ mb: 1, "& .MuiInputBase-root": { height: 40 } }}
                                                                    />

                                                                    <input
                                                                        type="range"
                                                                        min="0"
                                                                        max="200000"
                                                                        step="1000"
                                                                        value={block.financialTerms?.[service]?.creditLimit ?? 0}
                                                                        onChange={(e) =>
                                                                            updateFinancialTerm(
                                                                                index,
                                                                                service,
                                                                                "creditLimit",
                                                                                Number(e.target.value)
                                                                            )
                                                                        }
                                                                        style={{
                                                                            width: "100%",
                                                                            cursor: "pointer",
                                                                            accentColor: "green",
                                                                        }}
                                                                    />

                                                                    <MDTypography variant="caption" display="block" mb={2}>
                                                                        {(block.financialTerms?.[service]?.creditLimit ?? 0).toLocaleString()} $
                                                                    </MDTypography>

                                                                    <TextField
                                                                        select
                                                                        fullWidth
                                                                        label="Currency"
                                                                        value={block.financialTerms?.[service]?.currency ?? "USD"}
                                                                        onChange={(e) =>
                                                                            updateFinancialTerm(
                                                                                index,
                                                                                service,
                                                                                "currency",
                                                                                e.target.value
                                                                            )
                                                                        }
                                                                        InputLabelProps={{ shrink: true }}
                                                                        sx={{ "& .MuiInputBase-root": { height: 40 } }}
                                                                    >
                                                                        <MenuItem value="USD">USD</MenuItem>
                                                                        <MenuItem value="EUR">EUR</MenuItem>
                                                                        <MenuItem value="TRY">TRY</MenuItem>
                                                                        <MenuItem value="GBP">GBP</MenuItem>
                                                                    </TextField>
                                                                </MDBox>
                                                            </Grid>
                                                        ))}
                                                    </Grid>

                                                    <MDBox mt={3}>
                                                        <Grid container spacing={2} alignItems="center">
                                                            <Grid item xs={12}>
                                                                <MDTypography variant="subtitle2" fontWeight="bold" mt={2}>
                                                                    Bank Information
                                                                </MDTypography>
                                                            </Grid>

                                                            {(block.bankDetails?.length
                                                                    ? block.bankDetails
                                                                    : [{ bankName: "", swiftCode: "", iban: "", currency: "USD" }]
                                                            ).map((bank, bankIndex) => (
                                                                <React.Fragment key={bankIndex}>
                                                                    <Grid item xs={12} md={3}>
                                                                        <TextField
                                                                            fullWidth
                                                                            label="Bank Name"
                                                                            value={bank.bankName || ""}
                                                                            onChange={(e) =>
                                                                                updateBankDetail(
                                                                                    index,
                                                                                    bankIndex,
                                                                                    "bankName",
                                                                                    e.target.value.toUpperCase()
                                                                                )
                                                                            }
                                                                            sx={{ "& .MuiInputBase-root": { height: 56 } }}
                                                                        />
                                                                    </Grid>

                                                                    <Grid item xs={12} md={3}>
                                                                        <TextField
                                                                            fullWidth
                                                                            label="Swift Code"
                                                                            value={bank.swiftCode || ""}
                                                                            onChange={(e) =>
                                                                                updateBankDetail(
                                                                                    index,
                                                                                    bankIndex,
                                                                                    "swiftCode",
                                                                                    e.target.value.toUpperCase()
                                                                                )
                                                                            }
                                                                            sx={{ "& .MuiInputBase-root": { height: 56 } }}
                                                                        />
                                                                    </Grid>

                                                                    <Grid item xs={12} md={3}>
                                                                        <TextField
                                                                            fullWidth
                                                                            label="IBAN"
                                                                            value={bank.iban || ""}
                                                                            onChange={(e) =>
                                                                                updateBankDetail(
                                                                                    index,
                                                                                    bankIndex,
                                                                                    "iban",
                                                                                    e.target.value.toUpperCase()
                                                                                )
                                                                            }
                                                                            sx={{ "& .MuiInputBase-root": { height: 56 } }}
                                                                        />
                                                                    </Grid>

                                                                    <Grid item xs={12} md={2}>
                                                                        <TextField
                                                                            select
                                                                            fullWidth
                                                                            label="Currency"
                                                                            value={bank.currency || "USD"}
                                                                            onChange={(e) =>
                                                                                updateBankDetail(
                                                                                    index,
                                                                                    bankIndex,
                                                                                    "currency",
                                                                                    e.target.value
                                                                                )
                                                                            }
                                                                            sx={{ "& .MuiInputBase-root": { height: 56 } }}
                                                                        >
                                                                            <MenuItem value="USD">USD</MenuItem>
                                                                            <MenuItem value="EUR">EUR</MenuItem>
                                                                            <MenuItem value="TRY">TRY</MenuItem>
                                                                            <MenuItem value="GBP">GBP</MenuItem>
                                                                        </TextField>
                                                                    </Grid>

                                                                    <Grid item xs={12} md={1} display="flex" justifyContent="center">
                                                                        {bankIndex === (block.bankDetails?.length || 1) - 1 && (
                                                                            <AddRowButton onClick={() => addBankDetail(index)} tooltip="Add bank account" />
                                                                        )}

                                                                        {(block.bankDetails?.length || 1) > 1 && (
                                                                            <RemoveRowButton onClick={() => removeBankDetail(index, bankIndex)} tooltip="Remove bank account" />
                                                                        )}
                                                                    </Grid>
                                                                </React.Fragment>
                                                            ))}
                                                        </Grid>
                                                    </MDBox>
                                                </MDBox>
                                            ))}
                                        </MDBox>
                                        <MDBox mt={3}>
                                            <MDTypography variant="h6">Contact and Authorized Information</MDTypography>
                                        </MDBox>

                                        <Grid container spacing={2} alignItems="center" mt={2}>

                                            {/* Contact Person Name */}
                                            <Grid item xs={12} sm={3}>
                                                <TextField
                                                    type="text"
                                                    label="Contact Person Name"
                                                    value={contactPersonName}
                                                    onChange={(e) => setContactPersonName(e.target.value)}
                                                    fullWidth
                                                    InputLabelProps={{shrink: true}}
                                                    sx={{"& .MuiInputBase-root": {height: 40}}}
                                                />
                                            </Grid>

                                            {/* Title */}
                                            <Grid item xs={12} sm={3}>
                                                <TextField
                                                    type="text"
                                                    label="Title"
                                                    value={contactPersonTitle}
                                                    onChange={(e) => setContactPersonTitle(e.target.value)}
                                                    fullWidth
                                                    InputLabelProps={{shrink: true}}
                                                    sx={{"& .MuiInputBase-root": {height: 40}}}
                                                />
                                            </Grid>

                                            {/* Contact Information */}
                                            <Grid item xs={12} sm={6}>
                                                <TextField
                                                    type="text"
                                                    label="Contact Information"
                                                    value={contactPersonInfo}
                                                    onChange={(e) => setContactPersonInfo(e.target.value)}
                                                    fullWidth
                                                    InputLabelProps={{shrink: true}}
                                                    sx={{"& .MuiInputBase-root": {height: 40}}}
                                                />
                                            </Grid>

                                        </Grid>

                                        <MDBox mt={3}>
                                            <MDTypography variant="h6">Operational Information</MDTypography>
                                        </MDBox>
                                        <MDBox mt={3}>
                                            <Grid container spacing={2} alignItems="center">

                                                {/* ⭐ Service Provider Category */}
                                                <Grid item xs={12} sm={3} sx={{display: "flex", flexDirection: "column"}}>
                                                    <MDTypography variant="body1" fontSize={15} fontWeight="regular" color="text"
                                                                  sx={{mb: 1}}>
                                                        Service Provider Category
                                                    </MDTypography>

                                                    <div style={{display: "flex", alignItems: "center", height: 40}}>
                                                        {[1, 2, 3, 4, 5].map((star) => (
                                                            <span
                                                                key={star}
                                                                onClick={() => setServiceProviderCategory(star)}
                                                                style={{
                                                                    cursor: "pointer",
                                                                    color: star <= serviceProviderCategory ? "#FFD700" : "#CCCCCC",
                                                                    fontSize: "24px",
                                                                    marginRight: 4
                                                                }}
                                                            >
                    ★
                </span>
                                                        ))}
                                                    </div>
                                                </Grid>

                                                {/* Status */}
                                                <Grid item xs={12} sm={3}>
                                                    <Autocomplete
                                                        options={[
                                                            {label: "Active", value: "Active"},
                                                            {label: "De-Active", value: "De-Active"},
                                                            {label: "Prospect", value: "Prospect"},
                                                        ]}
                                                        getOptionLabel={(option) => option.label}
                                                        value={serviceProviderStatus ? { label: serviceProviderStatus } : null}
                                                        onChange={(event, newValue) => setServiceProviderStatus(newValue?.value || "")}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                label="Service Provider Status"
                                                                InputLabelProps={{shrink: true}}
                                                                sx={{"& .MuiInputBase-root": {height: 50}}}
                                                                fullWidth
                                                            />
                                                        )}
                                                        isOptionEqualToValue={(option, value) => option.value === value.value}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} sm={3}>
                                                    <Autocomplete
                                                        multiple
                                                        options={[
                                                            { label: "Exclusive SP" },
                                                            { label: "Strategic SP" },
                                                            { label: "Ad-hoc SP" },
                                                            { label: "Standard SP" },
                                                            { label: "Prospect SP" }
                                                        ]}
                                                        value={byTypeOfCollaboration.map((x) => ({ label: x }))}
                                                        isOptionEqualToValue={(o, val) => (o?.label ?? o) === (val?.label ?? val)}
                                                        onChange={(e, v) => setByTypeOfCollaboration(v.map((i) => i.label))}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                label="By Type of Collaboration"
                                                                fullWidth
                                                            />
                                                        )}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} sm={3}>
                                                    <Autocomplete
                                                        multiple
                                                        options={serviceProviderTypeOptions}
                                                        getOptionLabel={(option) => option.label}
                                                        value={serviceProviderTypesGroup.map((x) => ({ label: x }))}
                                                        onChange={(e, newValue) =>
                                                            setServiceProviderTypesGroup(newValue.map((i) => i.label))
                                                        }
                                                        isOptionEqualToValue={(option, value) =>
                                                            option.label === value.label
                                                        }
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                label="Service Provider Group"
                                                                fullWidth
                                                            />
                                                        )}
                                                    />
                                                </Grid>

                                            </Grid>
                                        </MDBox>


                                        <MDBox mt={3}>
                                            <MDTypography variant="h6">Technical and Specialized Areas</MDTypography>
                                        </MDBox>
                                        <Grid container spacing={2} alignItems="center" mt={2}>
                                            {/* serviceProvider ID Field */}
                                            <Grid item xs={4}>
                                                <TextField
                                                    type="text"
                                                    label="Service Provider ID"
                                                    value={serviceProviderNo}
                                                    disabled
                                                    fullWidth
                                                    sx={{"& .MuiInputBase-root": {height: 50}}}
                                                />
                                            </Grid>
                                        </Grid>

                                        <Grid container spacing={2} alignItems="center">
                                            <Grid item xs={12}>
                                                <MDTypography variant="h6" mt={2}>
                                                    References
                                                </MDTypography>
                                            </Grid>

                                            <Grid item xs={12} md={3}>
                                                <TextField
                                                    select
                                                    fullWidth
                                                    label="References (Who suggested this firm?)"
                                                    value={referenceSource}
                                                    onChange={(e) => {
                                                        setReferenceSource(e.target.value);
                                                        setReferencePerson("");
                                                        setExternalType("");
                                                        setExternalPersonName("");
                                                        setExternalForwardTo(null);
                                                        setExternalCompany(null);
                                                        setIsHouseAccountRef(false);
                                                    }}
                                                    sx={{ "& .MuiInputBase-root": { height: 56 } }}
                                                >
                                                    <MenuItem value="Sales Team">Sales Team</MenuItem>
                                                    <MenuItem value="Management">Management</MenuItem>
                                                    <MenuItem value="External">External</MenuItem>
                                                </TextField>
                                            </Grid>

                                            {referenceSource === "Sales Team" && (
                                                <Grid item xs={12} md={3}>
                                                    <TextField
                                                        select
                                                        fullWidth
                                                        label="Sales Team Person"
                                                        value={referencePerson}
                                                        onChange={(e) => setReferencePerson(e.target.value)}
                                                        sx={{ "& .MuiInputBase-root": { height: 56 } }}
                                                    >
                                                        {salesTeamPeople.map((p) => (
                                                            <MenuItem key={p} value={p}>
                                                                {p}
                                                            </MenuItem>
                                                        ))}
                                                    </TextField>
                                                </Grid>
                                            )}

                                            {referenceSource === "Management" && (
                                                <>
                                                    <Grid item xs={12} md={3}>
                                                        <TextField
                                                            select
                                                            fullWidth
                                                            label="Management Person"
                                                            value={referencePerson}
                                                            onChange={(e) => setReferencePerson(e.target.value)}
                                                            sx={{ "& .MuiInputBase-root": { height: 56 } }}
                                                        >
                                                            {managementPeople.map((p) => (
                                                                <MenuItem key={p} value={p}>
                                                                    {p}
                                                                </MenuItem>
                                                            ))}
                                                        </TextField>
                                                    </Grid>

                                                    <Grid item xs={12} md={3} display="flex" alignItems="center">
                                                        <FormControlLabel
                                                            control={
                                                                <Checkbox
                                                                    checked={isHouseAccountRef}
                                                                    onChange={(e) => setIsHouseAccountRef(e.target.checked)}
                                                                />
                                                            }
                                                            label="House Account"
                                                        />
                                                    </Grid>
                                                </>
                                            )}

                                            {referenceSource === "External" && (
                                                <>
                                                    <Grid item xs={12} md={3}>
                                                        <TextField
                                                            select
                                                            fullWidth
                                                            label="External Type"
                                                            value={externalType}
                                                            onChange={(e) => setExternalType(e.target.value)}
                                                            sx={{ "& .MuiInputBase-root": { height: 56 } }}
                                                        >
                                                            <MenuItem value="In Person">In Person</MenuItem>
                                                            <MenuItem value="Company">Company</MenuItem>
                                                        </TextField>
                                                    </Grid>

                                                    {externalType === "In Person" && (
                                                        <>
                                                            <Grid item xs={12} md={3}>
                                                                <TextField
                                                                    fullWidth
                                                                    label="Name Surname"
                                                                    value={externalPersonName}
                                                                    onChange={(e) => setExternalPersonName(e.target.value)}
                                                                    sx={{ "& .MuiInputBase-root": { height: 56 } }}
                                                                />
                                                            </Grid>

                                                            <Grid item xs={12} md={3}>
                                                                <Autocomplete
                                                                    fullWidth
                                                                    options={salesRepOptions}
                                                                    getOptionLabel={(o) => o?.label || ""}
                                                                    value={externalForwardTo || null}
                                                                    onChange={(e, v) => setExternalForwardTo(v)}
                                                                    renderInput={(params) => (
                                                                        <TextField
                                                                            {...params}
                                                                            label="Forwarded to (Sales Rep)"
                                                                            sx={{ "& .MuiInputBase-root": { height: 56 } }}
                                                                        />
                                                                    )}
                                                                />
                                                            </Grid>
                                                        </>
                                                    )}

                                                    {externalType === "Company" && (
                                                        <Grid item xs={12} md={3}>
                                                            <Autocomplete
                                                                fullWidth
                                                                loading={companyLoading}
                                                                options={companyOptions}
                                                                getOptionLabel={(o) => o?.label || ""}
                                                                value={externalCompany || null}
                                                                onChange={(e, v) => setExternalCompany(v)}
                                                                renderInput={(params) => (
                                                                    <TextField
                                                                        {...params}
                                                                        label="Company"
                                                                        sx={{ "& .MuiInputBase-root": { height: 56 } }}
                                                                    />
                                                                )}
                                                            />
                                                        </Grid>
                                                    )}
                                                </>
                                            )}                                </Grid>


                                    </MDBox>
                                    <Box mt={4} display="flex" justifyContent="flex-end">
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            onClick={() => setActiveTab(1)}
                                            sx={{ color: "#fff" }}
                                        >
                                            Next ➡️
                                        </Button>
                                    </Box>

                                </>
                            )}
                            {activeTab === 1 && (
                                <>
                                    <MDBox mt={3}>
                                        <MDTypography variant="h6">Top Management</MDTypography>
                                        <Grid container spacing={2} mt={1} alignItems="center">
                                            {representatives.map((rep, index) => (
                                                <React.Fragment key={index}>
                                                    <Grid item xs={12} sm={2}>
                                                        <TextField label="Name" value={rep.name}
                                                                   onChange={(e) => updateRepresentative(index, "name", e.target.value)}
                                                                   fullWidth sx={{ "& .MuiInputBase-root": { height: 56 } }} />
                                                    </Grid>
                                                    <Grid item xs={12} sm={1}>
                                                        <TextField label="Phone" value={rep.phone}
                                                                   onChange={(e) => updateRepresentative(index, "phone", e.target.value)}
                                                                   fullWidth sx={{ "& .MuiInputBase-root": { height: 56 } }} />
                                                    </Grid>
                                                    <Grid item xs={12} sm={2}>
                                                        <TextField label="Email" value={rep.email}
                                                                   onChange={(e) => updateRepresentative(index, "email", e.target.value)}
                                                                   fullWidth sx={{ "& .MuiInputBase-root": { height: 56 } }} />
                                                    </Grid>
                                                    <Grid item xs={12} sm={1}>
                                                        <TextField label="Title" value={rep.title}
                                                                   onChange={(e) => updateRepresentative(index, "title", e.target.value)}
                                                                   fullWidth sx={{ "& .MuiInputBase-root": { height: 56 } }} />
                                                    </Grid>
                                                    <Grid item xs={12} sm={1}>
                                                        <Autocomplete
                                                            multiple
                                                            options={departmentOptions}
                                                            value={rep.department}
                                                            onChange={(_, v) => updateRepresentative(index, "department", v)}
                                                            renderInput={(params) => (
                                                                <TextField {...params}
                                                                           label="Depart."
                                                                           sx={{ "& .MuiInputBase-root": { minHeight: 56, alignItems: "center" } }} />
                                                            )}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} sm={2}>
                                                        <Autocomplete
                                                            options={countryOptions}
                                                            getOptionLabel={(o) => o.label}
                                                            value={rep.country ? countryOptions.find(c => c.label === rep.country) || null : null}
                                                            isOptionEqualToValue={(o, val) => (o?.label ?? o) === (val?.label ?? val)}
                                                            onChange={async (_e, v) => {
                                                                const nextCountry = v?.label || "";
                                                                updateRepresentative(index, "country", nextCountry);
                                                                updateRepresentative(index, "city", "");
                                                                if (nextCountry) await ensureCitiesLoaded(nextCountry);
                                                            }}
                                                            renderInput={(params) => (
                                                                <TextField {...params} label="Country" sx={{ "& .MuiInputBase-root": { height: 56 } }} />
                                                            )}
                                                        />

                                                    </Grid>
                                                    <Grid item xs={12} sm={2}>
                                                        <Autocomplete
                                                            freeSolo
                                                            disabled={!rep.country}
                                                            options={rep.country ? (repCityOptionsMap[rep.country] || []) : []}
                                                            value={rep.city || ""}
                                                            onChange={(_e, v) => updateRepresentative(index, "city", v || "")}
                                                            onInputChange={(_e, v) => updateRepresentative(index, "city", v || "")}
                                                            renderInput={(params) => (
                                                                <TextField
                                                                    {...params}
                                                                    label="City"
                                                                    fullWidth
                                                                    sx={{ "& .MuiInputBase-root": { height: 56 } }}
                                                                />
                                                            )}
                                                        />
                                                    </Grid>


                                                    <Grid item xs={12} sm={1} display="flex" justifyContent="center">                                                    {index === representatives.length - 1 && (
                                                        <AddRowButton onClick={addRepresentative} tooltip="Add representative" />
                                                    )}
                                                        {representatives.length > 1 && (
                                                            <RemoveRowButton onClick={() => removeRepresentative(index)} tooltip="Remove representative" />
                                                        )}
                                                    </Grid>
                                                </React.Fragment>
                                            ))}
                                        </Grid>
                                    </MDBox>
                                    <MDBox mt={4}>
                                        <MDTypography variant="h6">Finance Representatives</MDTypography>
                                        <Grid container spacing={2} mt={1} alignItems="center">
                                            {financeRepresentatives.map((rep, index) => (
                                                <React.Fragment key={index}>
                                                    <Grid item xs={12} sm={2}>
                                                        <TextField label="Name" value={rep.name}
                                                                   onChange={(e) => updateFinanceRepresentative(index, "name", e.target.value)}
                                                                   fullWidth sx={{ "& .MuiInputBase-root": { height: 56 } }} />
                                                    </Grid>
                                                    <Grid item xs={12} sm={1}>
                                                        <TextField label="Phone" value={rep.phone}
                                                                   onChange={(e) => updateFinanceRepresentative(index, "phone", e.target.value)}
                                                                   fullWidth sx={{ "& .MuiInputBase-root": { height: 56 } }} />
                                                    </Grid>
                                                    <Grid item xs={12} sm={2}>
                                                        <TextField label="Email" value={rep.email}
                                                                   onChange={(e) => updateFinanceRepresentative(index, "email", e.target.value)}
                                                                   fullWidth sx={{ "& .MuiInputBase-root": { height: 56 } }} />
                                                    </Grid>
                                                    <Grid item xs={12} sm={1}>
                                                        <TextField label="Title" value={rep.title}
                                                                   onChange={(e) => updateFinanceRepresentative(index, "title", e.target.value)}
                                                                   fullWidth sx={{ "& .MuiInputBase-root": { height: 56 } }} />
                                                    </Grid>
                                                    <Grid item xs={12} sm={1}>
                                                        <Autocomplete
                                                            multiple
                                                            options={departmentOptions}
                                                            value={rep.department}
                                                            onChange={(_, v) => updateFinanceRepresentative(index, "department", v)}
                                                            renderInput={(params) => (
                                                                <TextField {...params}
                                                                           label="Depart."
                                                                           sx={{ "& .MuiInputBase-root": { minHeight: 56, alignItems: "center" } }} />
                                                            )}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} sm={2}>
                                                        <Autocomplete
                                                            options={countryOptions}
                                                            getOptionLabel={(o) => o.label}
                                                            value={
                                                                rep.country
                                                                    ? countryOptions.find((c) => c.label === rep.country) || null
                                                                    : null
                                                            }
                                                            onChange={async (_e, v) => {
                                                                const nextCountry = v?.label || "";
                                                                updateFinanceRepresentative(index, "country", nextCountry);
                                                                updateFinanceRepresentative(index, "city", "");
                                                                if (nextCountry) await ensureCitiesLoaded(nextCountry);
                                                            }}
                                                            renderInput={(params) => (
                                                                <TextField
                                                                    {...params}
                                                                    label="Country"
                                                                    sx={{ "& .MuiInputBase-root": { height: 56 } }}
                                                                />
                                                            )}
                                                            isOptionEqualToValue={(a, b) => a.label === b.label}
                                                        />
                                                    </Grid>

                                                    <Grid item xs={12} sm={2}>
                                                        <Autocomplete
                                                            freeSolo
                                                            disabled={!rep.country}
                                                            options={rep.country ? repCityOptionsMap[rep.country] || [] : []}
                                                            value={rep.city || ""}
                                                            onChange={(_e, v) => updateFinanceRepresentative(index, "city", v || "")}
                                                            onInputChange={(_e, v) => updateFinanceRepresentative(index, "city", v || "")}
                                                            renderInput={(params) => (
                                                                <TextField
                                                                    {...params}
                                                                    label="City"
                                                                    fullWidth
                                                                    sx={{ "& .MuiInputBase-root": { height: 56 } }}
                                                                />
                                                            )}
                                                        />
                                                    </Grid>

                                                    <Grid item xs={12} sm={1} display="flex" justifyContent="center">
                                                        {index === financeRepresentatives.length - 1 && (
                                                            <AddRowButton onClick={addFinanceRepresentative} tooltip="Add finance representative" />
                                                        )}
                                                        {financeRepresentatives.length > 1 && (
                                                            <RemoveRowButton onClick={() => removeFinanceRepresentative(index)} tooltip="Remove finance representative" />
                                                        )}
                                                    </Grid>
                                                </React.Fragment>
                                            ))}
                                        </Grid>
                                    </MDBox>
                                    <MDBox mt={4}>
                                        <MDTypography variant="h6">Pricing Representatives</MDTypography>
                                        <Grid container spacing={2} mt={1} alignItems="center">
                                            {pricingRepresentatives.map((rep, index) => (
                                                <React.Fragment key={index}>
                                                    <Grid item xs={12} sm={2}>
                                                        <TextField
                                                            label="Name"
                                                            value={rep.name}
                                                            onChange={(e) => updatePricingRepresentative(index, "name", e.target.value)}
                                                            fullWidth
                                                            sx={{ "& .MuiInputBase-root": { height: 56 } }}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} sm={1}>
                                                        <TextField
                                                            label="Phone"
                                                            value={rep.phone}
                                                            onChange={(e) => updatePricingRepresentative(index, "phone", e.target.value)}
                                                            fullWidth
                                                            sx={{ "& .MuiInputBase-root": { height: 56 } }}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} sm={2}>
                                                        <TextField
                                                            label="Email"
                                                            value={rep.email}
                                                            onChange={(e) => updatePricingRepresentative(index, "email", e.target.value)}
                                                            fullWidth
                                                            sx={{ "& .MuiInputBase-root": { height: 56 } }}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} sm={1}>
                                                        <TextField
                                                            label="Title"
                                                            value={rep.title}
                                                            onChange={(e) => updatePricingRepresentative(index, "title", e.target.value)}
                                                            fullWidth
                                                            sx={{ "& .MuiInputBase-root": { height: 56 } }}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} sm={1}>
                                                        <Autocomplete
                                                            multiple
                                                            options={departmentOptions}
                                                            value={rep.department}
                                                            onChange={(_, v) => updatePricingRepresentative(index, "department", v)}
                                                            renderInput={(params) => (
                                                                <TextField
                                                                    {...params}
                                                                    label="Depart."
                                                                    sx={{
                                                                        "& .MuiInputBase-root": {
                                                                            minHeight: 56,
                                                                            alignItems: "center",
                                                                        },
                                                                    }}
                                                                />
                                                            )}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} sm={2}>
                                                        <Autocomplete
                                                            options={countryOptions}
                                                            getOptionLabel={(o) => o.label}
                                                            value={rep.country ? { label: rep.country } : null}
                                                            isOptionEqualToValue={(o, val) => (o?.label ?? o) === (val?.label ?? val)}
                                                            onChange={(e, v) =>
                                                                updatePricingRepresentative(index, "country", v?.label || "")
                                                            }
                                                            renderInput={(params) => (
                                                                <TextField
                                                                    {...params}
                                                                    label="Country"
                                                                    sx={{ "& .MuiInputBase-root": { height: 56 } }}
                                                                />
                                                            )}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} sm={2}>
                                                        <Autocomplete
                                                            freeSolo
                                                            disabled={!rep.country}
                                                            options={rep.country ? repCityOptionsMap[rep.country] || [] : []}
                                                            value={rep.city || ""}
                                                            onChange={(_e, v) => updatePricingRepresentative(index, "city", v || "")}
                                                            onInputChange={(_e, v) => updatePricingRepresentative(index, "city", v || "")}
                                                            renderInput={(params) => (
                                                                <TextField
                                                                    {...params}
                                                                    label="City"
                                                                    fullWidth
                                                                    sx={{ "& .MuiInputBase-root": { height: 56 } }}
                                                                />
                                                            )}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} sm={1} display="flex" justifyContent="center">
                                                        {index === pricingRepresentatives.length - 1 && (
                                                            <AddRowButton onClick={addPricingRepresentative} tooltip="Add pricing representative" />
                                                        )}
                                                        {pricingRepresentatives.length > 1 && (
                                                            <RemoveRowButton onClick={() => removePricingRepresentative(index)} tooltip="Remove pricing representative" />
                                                        )}
                                                    </Grid>
                                                </React.Fragment>
                                            ))}
                                        </Grid>
                                    </MDBox>
                                    <MDBox mt={4}>
                                        <MDTypography variant="h6">Operation Representatives</MDTypography>
                                        <Grid container spacing={2} mt={1} alignItems="center">
                                            {operationRepresentatives.map((rep, index) => (
                                                <React.Fragment key={index}>
                                                    <Grid item xs={12} sm={2}>
                                                        <TextField
                                                            label="Name"
                                                            value={rep.name}
                                                            onChange={(e) => updateOperationRepresentative(index, "name", e.target.value)}
                                                            fullWidth
                                                            sx={{ "& .MuiInputBase-root": { height: 56 } }}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} sm={1}>
                                                        <TextField
                                                            label="Phone"
                                                            value={rep.phone}
                                                            onChange={(e) => updateOperationRepresentative(index, "phone", e.target.value)}
                                                            fullWidth
                                                            sx={{ "& .MuiInputBase-root": { height: 56 } }}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} sm={2}>
                                                        <TextField
                                                            label="Email"
                                                            value={rep.email}
                                                            onChange={(e) => updateOperationRepresentative(index, "email", e.target.value)}
                                                            fullWidth
                                                            sx={{ "& .MuiInputBase-root": { height: 56 } }}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} sm={1}>
                                                        <TextField
                                                            label="Title"
                                                            value={rep.title}
                                                            onChange={(e) => updateOperationRepresentative(index, "title", e.target.value)}
                                                            fullWidth
                                                            sx={{ "& .MuiInputBase-root": { height: 56 } }}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} sm={1}>
                                                        <Autocomplete
                                                            multiple
                                                            options={departmentOptions}
                                                            value={rep.department}
                                                            onChange={(event, newValue) =>
                                                                updateOperationRepresentative(index, "department", newValue)
                                                            }
                                                            renderInput={(params) => (
                                                                <TextField
                                                                    {...params}
                                                                    label="Depart."
                                                                    fullWidth
                                                                    sx={{
                                                                        "& .MuiInputBase-root": {
                                                                            minHeight: 56,
                                                                            alignItems: "center",
                                                                        },
                                                                    }}
                                                                />
                                                            )}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} sm={2}>
                                                        <Autocomplete
                                                            options={countryOptions}
                                                            getOptionLabel={(o) => o.label}
                                                            value={
                                                                rep.country
                                                                    ? countryOptions.find((c) => c.label === rep.country) || null
                                                                    : null
                                                            }
                                                            onChange={async (_e, v) => {
                                                                const nextCountry = v?.label || "";
                                                                updateOperationRepresentative(index, "country", nextCountry);
                                                                updateOperationRepresentative(index, "city", "");
                                                                if (nextCountry) await ensureCitiesLoaded(nextCountry);
                                                            }}
                                                            renderInput={(params) => (
                                                                <TextField
                                                                    {...params}
                                                                    label="Country"
                                                                    sx={{ "& .MuiInputBase-root": { height: 56 } }}
                                                                />
                                                            )}
                                                            isOptionEqualToValue={(a, b) => a.label === b.label}
                                                        />
                                                    </Grid>

                                                    <Grid item xs={12} sm={2}>
                                                        <Autocomplete
                                                            freeSolo
                                                            disabled={!rep.country}
                                                            options={rep.country ? repCityOptionsMap[rep.country] || [] : []}
                                                            value={rep.city || ""}
                                                            onChange={(_e, v) => updateOperationRepresentative(index, "city", v || "")}
                                                            onInputChange={(_e, v) => updateOperationRepresentative(index, "city", v || "")}
                                                            renderInput={(params) => (
                                                                <TextField
                                                                    {...params}
                                                                    label="City"
                                                                    fullWidth
                                                                    sx={{ "& .MuiInputBase-root": { height: 56 } }}
                                                                />
                                                            )}
                                                        />
                                                    </Grid>

                                                    <Grid item xs={12} sm={1} display="flex" justifyContent="center">
                                                        {index === operationRepresentatives.length - 1 && (
                                                            <AddRowButton onClick={addOperationRepresentative} tooltip="Add operation representative" />
                                                        )}
                                                        {operationRepresentatives.length > 1 && (
                                                            <RemoveRowButton onClick={() => removeOperationRepresentative(index)} tooltip="Remove operation representative" />
                                                        )}
                                                    </Grid>
                                                </React.Fragment>
                                            ))}
                                        </Grid>
                                    </MDBox>
                                    <MDBox mt={4}>
                                        <MDTypography variant="h6">Notes and Additional Information</MDTypography>
                                    </MDBox>
                                    <Grid container spacing={2} alignItems="center" mt={2}>
                                        <Grid item xs={6}>
                                            <TextField
                                                type="text"
                                                label="Special Notes"
                                                value={specialNotes}
                                                onChange={(e) => setSpecialNotes(e.target.value)}
                                                fullWidth
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextField
                                                type="text"
                                                label="Transaction History Notes"
                                                value={transactionNotes}
                                                onChange={(e) => setTransactionNotes(e.target.value)}
                                                fullWidth
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <TextField
                                                type="text"
                                                label="Complaint/Support History"
                                                value={complaintHistory}
                                                onChange={(e) => setComplaintHistory(e.target.value)}
                                                fullWidth
                                            />
                                        </Grid>

                                    </Grid>
                                    <LocalizationProvider dateAdapter={AdapterDateFns} locale={tr}>
                                        <Grid container spacing={2} mt={4}>
                                            {/* Insurance - Vehicle */}
                                            <Grid item xs={12} sm={6} md={2}>
                                                <MDBox display="flex" flexDirection="column" alignItems="center">
                                                    <MDTypography variant="caption" fontWeight="bold" textAlign="center"
                                                                  sx={TITLE_SX}>
                                                        Vehicle Insurances
                                                    </MDTypography>
                                                    <MDBox sx={DROPZONE_WRAPPER_SX}>
                                                        <MDDropzone
                                                            options={{
                                                                addRemoveLinks: true,
                                                                maxFilesize: 100, // MB
                                                                maxFiles: 1,
                                                                acceptedFiles: ".pdf,.doc,.docx,.png,.jpg",
                                                                timeout: 0,
                                                            }}
                                                            onChange={(files) => setVehicleInsurances(files)}
                                                            style={DZ_STYLE}
                                                        />
                                                    </MDBox>
                                                    <UploadedFilePreview
                                                        file={vehicleInsurances}
                                                        layout="stack"
                                                        onRemove={() => setVehicleInsurances([])}
                                                    />
                                                </MDBox>
                                            </Grid>
                                            <Grid item xs={12} sm={6} md={2}>
                                                <DatePicker
                                                    label="Vehicle Insurances Validity"
                                                    value={vehicleInsurancesDate}
                                                    onChange={(newDate) => setVehicleInsurancesDate(newDate || new Date())}
                                                    format="dd/MM/yyyy"
                                                    renderInput={(params) => <TextField {...params} fullWidth/>}
                                                    slotProps={{
                                                        textField: {
                                                            variant: "standard",
                                                            size: "small",
                                                            sx: {
                                                                minWidth: 200,
                                                                "& .MuiInputBase-root": {height: 40}
                                                            }
                                                        }
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6} md={2}>
                                                <MDBox display="flex" flexDirection="column" alignItems="center">
                                                    <MDTypography variant="caption" fontWeight="bold" textAlign="center"
                                                                  sx={TITLE_SX}>
                                                        MTL Insurances
                                                    </MDTypography>
                                                    <MDBox sx={DROPZONE_WRAPPER_SX}>
                                                        <MDDropzone
                                                            options={{
                                                                addRemoveLinks: true,
                                                                maxFilesize: 100, // MB
                                                                maxFiles: 1,
                                                                acceptedFiles: ".pdf,.doc,.docx,.png,.jpg",
                                                                timeout: 0,
                                                            }}
                                                            onChange={(files) => setMtlInsurances(files)}
                                                            style={DZ_STYLE}
                                                        />
                                                    </MDBox>
                                                    <UploadedFilePreview
                                                        file={mtlInsurances}
                                                        layout="stack"
                                                        onRemove={() => setMtlInsurances([])}
                                                    />
                                                </MDBox>
                                            </Grid>
                                            <Grid item xs={12} sm={6} md={2}>
                                                <DatePicker
                                                    label="MTL Insurances Validity"
                                                    value={mtlInsurancesDate}
                                                    onChange={(newDate) => setMtlInsurancesDate(newDate || new Date())}
                                                    format="dd/MM/yyyy"
                                                    renderInput={(params) => <TextField {...params} fullWidth/>}
                                                    slotProps={{
                                                        textField: {
                                                            variant: "standard",
                                                            size: "small",
                                                            sx: {
                                                                minWidth: 200,
                                                                "& .MuiInputBase-root": {height: 40}
                                                            }
                                                        }
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6} md={2}>
                                                <MDBox display="flex" flexDirection="column" alignItems="center">
                                                    <MDTypography variant="caption" fontWeight="bold" textAlign="center"
                                                                  sx={TITLE_SX}>
                                                        Cargo and Liability Policy
                                                    </MDTypography>
                                                    <MDBox sx={DROPZONE_WRAPPER_SX}>
                                                        <MDDropzone
                                                            options={{
                                                                addRemoveLinks: true,
                                                                maxFilesize: 100, // MB
                                                                maxFiles: 1,
                                                                acceptedFiles: ".pdf,.doc,.docx,.png,.jpg",
                                                                timeout: 0,
                                                            }}
                                                            onChange={(files) => setCargoPolicy(files)}
                                                            style={DZ_STYLE}
                                                        />
                                                    </MDBox>
                                                    <UploadedFilePreview
                                                        file={cargoPolicy}
                                                        layout="stack"
                                                        onRemove={() => setCargoPolicy([])}
                                                    />
                                                </MDBox>
                                            </Grid>
                                            <Grid item xs={12} sm={6} md={2}>
                                                <DatePicker
                                                    label="Cargo Policy Validity"
                                                    value={cargoPolicyDate}
                                                    onChange={(newDate) => setCargoPolicyDate(newDate || new Date())}
                                                    format="dd/MM/yyyy"
                                                    renderInput={(params) => <TextField {...params} fullWidth/>}
                                                    slotProps={{
                                                        textField: {
                                                            variant: "standard",
                                                            size: "small",
                                                            sx: {
                                                                minWidth: 200,
                                                                "& .MuiInputBase-root": {height: 40}
                                                            }
                                                        }
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6} md={2}>
                                                <MDBox display="flex" flexDirection="column" alignItems="center">
                                                    <MDTypography variant="caption" fontWeight="bold" textAlign="center"
                                                                  sx={TITLE_SX}>
                                                        Service Provider Agreement
                                                    </MDTypography>
                                                    <MDBox sx={DROPZONE_WRAPPER_SX}>
                                                        <MDDropzone
                                                            options={{
                                                                addRemoveLinks: true,
                                                                maxFilesize: 100, // MB
                                                                maxFiles: 1,
                                                                acceptedFiles: ".pdf,.doc,.docx,.png,.jpg",
                                                                timeout: 0,
                                                            }}
                                                            onChange={(files) => setProviderAgreement(files)}
                                                            style={DZ_STYLE}
                                                        />
                                                    </MDBox>
                                                    <UploadedFilePreview
                                                        file={providerAgreement}
                                                        layout="stack"
                                                        onRemove={() => setProviderAgreement([])}
                                                    />
                                                </MDBox>
                                            </Grid>
                                            <Grid item xs={12} sm={6} md={2}>
                                                <DatePicker
                                                    label="Provider Agreement Validity"
                                                    value={providerAgreementDate}
                                                    onChange={(newDate) => setProviderAgreementDate(newDate || new Date())}
                                                    format="dd/MM/yyyy"
                                                    renderInput={(params) => <TextField {...params} fullWidth/>}
                                                    slotProps={{
                                                        textField: {
                                                            variant: "standard",
                                                            size: "small",
                                                            sx: {
                                                                minWidth: 200,
                                                                "& .MuiInputBase-root": {height: 40}
                                                            }
                                                        }
                                                    }}
                                                />
                                            </Grid>
                                        </Grid>
                                    </LocalizationProvider>
                                    <div>
                                        <Box
                                            mt={6}
                                            mb={3}
                                            display="flex"
                                            justifyContent="space-between"
                                            alignItems="center"
                                        >
                                            <Button
                                                variant="contained"
                                                onClick={() => setActiveTab(0)}
                                                sx={{
                                                    backgroundColor: "#ff7400",
                                                    color: "#ffffff",
                                                    fontWeight: "bold",
                                                    "&:hover": { backgroundColor: "#ff7400" },
                                                }}
                                            >
                                                ⬅️ Back
                                            </Button>
                                            <Button
                                                variant="contained"
                                                onClick={submitHandler}
                                                sx={{
                                                    backgroundColor: "#0B1F3A",
                                                    color: "#FFFFFF",
                                                    fontWeight: "bold",
                                                    "&:hover": { backgroundColor: "#43a047" },
                                                }}
                                            >
                                                {isEditing ? "Update Service Provider" : "Create Service Provider"}
                                            </Button>
                                        </Box>
                                    </div>
                                </>
                            )}
                        </Grid>
                    </Grid>
                </MDBox>
                </ReadOnlyFieldset>
            </MDBox>
            <br /><br />
            <Snackbar
                open={snackbar.open}
                autoHideDuration={4000}
                onClose={handleSnackbarClose}
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
            >
                <Alert
                    onClose={handleSnackbarClose}
                    severity={snackbar.severity}
                    sx={{ width: "100%" }}
                    variant="filled"
                >
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </>
    );

    return isModal ? (
        formContent
    ) : (
        <DashboardLayout>
            <DashboardNavbar />

            {formContent}
            <Footer />
        </DashboardLayout>
    );
};
export default CreateServiceProvider;
